<script>
import gql from 'graphql-tag'
import { promotions } from '@/config'
const { amount, currencyCode } = promotions

import { applyPromoCode } from '@/graph/mutations/user'

import { Plugins } from '@capacitor/core'
const { Clipboard } = Plugins

const VIEWER_REFERRAL_CODE = gql`
  query {
    user: getViewer {
      id
      referralCode
    }
  }
`

export default {
  name: 'PromotionsView',
  apollo: {
    user: {
      query: VIEWER_REFERRAL_CODE,
      fetchPolicy: 'cache-first'
    }
  },
  data: () => ({
    form: { code: '' },
    submitting: false,

    amount: `${currencyCode} ${amount}`,
    minSpend: `${currencyCode} ${amount * 3}`
  }),
  methods: {
    copyToClipboard() {
      Clipboard.write({ string: this.user.referralCode })
      this.$toast('Code copied to clipboard')
    },

    applyCode() {
      if (!this.form.code || this.submitting) return
      this.submitting = true

      applyPromoCode(this.form.code)
        .then(x => {
          const value = x.data.promotion
          this.$toast(`${value} RM credited to your account`)
          this.form.code = ''
        })
        .finally(() => {
          this.submitting = false
        })
    }
  }
}
</script>

<template>
  <transition name="slide-up" appear>
    <!-- Promotions view page -->
    <div class="view-grid">
      <div class="px-5">
        <div class="display-1 font-weight-bold mb-2">
          Refer &amp; earn
        </div>
        <div>
          <p class="body-2">
            When someone signs up on Pona with your invite code, they'll get
            {{ amount }} credit.
          </p>
          <p class="body-2">
            Once they've completed an order that's {{ minSpend }} or more,
            you'll be rewarded with {{ amount }} credit.
          </p>

          <div
            class="d-flex justify-space-between align-center flex-wrap mt-10"
          >
            <div>
              <v-skeleton-loader
                :loading="$apollo.queries.user.loading"
                transition="fade-transition"
                height="32"
                type="heading"
              >
                <div class="headline grey--text text--darken-4">
                  {{ user && user.referralCode }}
                </div>
              </v-skeleton-loader>
              <span class="body-2 grey--text">
                Your invite code
              </span>
            </div>

            <v-btn rounded outlined color="primary" @click="copyToClipboard">
              Copy
            </v-btn>
          </div>
        </div>
      </div>

      <div class="content-bottom apply-code">
        <v-row no-gutter>
          <v-col cols="7" align-self="end">
            <form @submit.prevent="applyCode()">
              <v-text-field v-model="form.code" label="Enter promo code" />
              <v-btn :loading="submitting" type="submit" rounded outlined>
                Apply
              </v-btn>
            </form>
          </v-col>
          <v-col cols="5">
            <div class="share-illustration">
              <v-img src="@/assets/master_share.svg" />
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
  </transition>
</template>

<style lang="sass" scoped>
.promotions-view
  min-height: 100%

.v-btn
  border-color: #aaa
  width: 112px

.share-illustration
  max-width: 500px
</style>
